import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { useHistory } from "react-router-dom";

const SimpleSidebarComponent = ({ href, name, icon }: any) => {
    const history = useHistory();
    console.log(history, href);

    return (
        <ListItem
            button
            style={{ cursor: "pointer" }}
            onClick={() => {
                history.push(href);
            }}
        >
            {icon && <ListItemIcon>{icon}</ListItemIcon>}
            <ListItemText primary={name} />
        </ListItem>
    );
};

export default SimpleSidebarComponent;
